<style lang="scss" scoped>
    @import "../../../../sass/variables";

    .subjects {
        width: 888px;
        margin: 20px auto 0 auto;
        display: block;
        list-style: none;
        padding: 0;
    }

    .divider {
        margin: 0 30% 0 30%;
    }

    .btn-change {
        text-align: center;
        margin-top: 30px;
    }

    .refresh {
        display: flex;
        &:after {
            width: 26px;
            height: 26px;
            background: url("../../../../images/refresh.svg") no-repeat center;
            content: "";
            display: inline-block;
        }
    }
</style>

<template>
    <div>
        <div class="ui horizontal divider">专题·最新</div>
        <ul class="subjects">
            <bcms-cell v-for="subject in subjects"
                       :key="subject.s_alias"
                       :icon="subject.icon.m"
                       :title="subject.title"
                       :intro="subject.intro"
                       :followers="0"
                       :articlesCount="subject.articles_count"
                       :url="subject.url"></bcms-cell>
        </ul>
        <div class="btn-change">
            <button class="ui basic black button mini" @click="changePage">换一批</button>
        </div>
    </div>
</template>

<script>
    import 'semantic-ui-divider/divider.min.css';
    import 'semantic-ui-button/button.min.css';
    import axios from 'axios';
    import BcmsCell from '../subject/cell.vue';

    export default {
        data() {
            return {
                subjects: []
            }
        },
        components: {
            BcmsCell,
        },
        mounted() {
            this.changePage();
        },
        methods: {
            changePage() {
                axios.get('/s')
                    .then((response) => {
                        this.subjects = response.data.data;
                    })
                    .catch((error) => {
                        alert("网络异常，请检查网络！");
                    });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/web/components/index/subjects.vue